import {
  BreakpointContext,
  BreakpointContextValue,
} from '@danske/sapphire-react-context';
import { Breakpoints } from '../utils/useBreakpointTokens';
import { useContext } from 'react';

export function useBreakpointContext(): BreakpointContextValue<Breakpoints> | null {
  return useContext(
    BreakpointContext
  ) as BreakpointContextValue<Breakpoints> | null;
}
